export const createLabel = (id: number, label: string) => `${id}. ${label}`;
